// @flow

import styled, { css } from 'styled-components';
import media from '../../../../../../helpers/media';
import type { Theme } from '../../../../../../types';

type Props = {
  active: boolean,
  onClick: Function,
  blocksPerRow: number,
  blockCount: number,
  boxed: boolean,
  mostChosen: ?boolean,
  className: ?string,
  variant: ?string,
};

const getMaximumWidth = (maxBlocks: number, blockCount: number): string => {
  if (blockCount <= maxBlocks) { return `${100 / blockCount}%` }
  return `${100 / maxBlocks}%`;
};

const defaultStyling = css`
  background-color: ${props => props.theme.tileSelect.backgroundColor};
  border: 3px solid ${props => (props.active ? props.theme.tileSelect.borderColor : props.theme.tileSelect.backgroundColor)};
  border-radius: ${props => props.theme.tileSelect.borderRadius};
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
  padding: 1.25rem;

  &::after,
  &::before {
    box-sizing: border-box;
    content: '';
    display: ${props => (props.active ? 'block' : 'none')};
    position: absolute;
  }

  &::after {
    border: 2px solid ${props => props.theme.tileSelect.borderColor};
    border-radius: 50%;
    height: 1em;
    right: .3rem;
    top: .35rem;
    width: 1em;
    font-size: 1.375rem;
  }

  &::before {
    border: 3px solid ${props => props.theme.tileSelect.borderColor};
    border-width: 0 0 2px 2px;
    height: .4rem;
    transform: rotate(-45deg) skewY(-5deg);
    transform-origin: center;
    right: .65rem;
    top: .75rem;
    width: .65rem;
  }
`;

const smallTileStyling = css`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: .75rem;

  & > h3 {
    margin-bottom: 0;
  }

  &::after,
  &::before {
    display: none;
  }
`;

const getVariantStyling = (variant: ?string) => {
  switch (variant) {
    case 'small':
      return smallTileStyling;
    default:
      return null;
  }
};

export const Tile = styled<any, Theme, Props>('section')`
  box-sizing: border-box;
  cursor: pointer;
  flex-grow: 1;
  margin: .5rem;
  position: relative;
  user-select: none;

  ${props => (!props.boxed ? null : defaultStyling)}

  ${props => getVariantStyling(props.variant)}

  ${props => (props.blocksPerRow > 1 ? null : css`margin-bottom: 1rem;`)}

  ${props => props.blocksPerRow > 0 && css`
    width: calc(100% - 1rem);
    ${media.sm(css`
      max-width: calc(${getMaximumWidth(props.blocksPerRow, 2)} - 1rem);
    `)};

    ${media.md(css`
      max-width: calc(${getMaximumWidth(props.blocksPerRow, 3)} - 1rem);
    `)};

    ${media.lg(css`
      max-width: calc(${getMaximumWidth(props.blocksPerRow, props.blockCount)} - 1rem);
    `)};
  `}

  ${props => props.blocksPerRow === 0 && css`
    flex-grow: 0;
    margin-bottom: .5rem;
  `}

`;

export default null;
